import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/edit.module.css";
import axios from "axios";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { useLocation, useParams } from "react-router";
import Alert from "../../../Components/Alert/alert";
import { Url, getUser } from "../../../Constants/globals";
import TextareaAutosize from 'react-autosize-textarea';
import Switch from "../../../Components/Switch/switch";
import { HiOutlineMegaphone } from "react-icons/hi2";
import { HiPlusCircle, HiXCircle } from "react-icons/hi";
import stylesModal from "../../../Components/DeleteModal/deletemodal.module.css";
import GoBack from "../../../Components/GoBack/goback";

function PreviewModal({ closeModal, title, message, file, filename }) {

  const [loading, setLoading] = useState(true);
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [imgUrl, setImgUrl] = useState("");

  async function getFile() {
    if (filename === "" || filename.substring(filename.length - 3, filename.length) === "pdf") return setLoading(false);
    if (typeof file === "string") {
      try {
        const res = await axios.get(`${Url}/image/${filename}`, {
          headers: {
            Authorization: "Bearer " + getUser().token,
          },
          responseType: "arraybuffer"
        });
        const blob = new Blob([res.data]);
        const newFile = URL.createObjectURL(blob);
        setImgUrl(newFile);
      }
      catch (err) {
        return setLoading(false);
      }
    }
    else {
      const newFile = URL.createObjectURL(file);
      setImgUrl(newFile);
    }
    return setLoading(false);
  }

  useEffect(() => {
    getFile();
  }, []);

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
      {
        loading ?
          <div className={stylesModal.center}>
            <div className={stylesModal.column} style={{ alignItems: "flex-start", width: "420px", height: "80vh", overflowX: "hidden" }} />
          </div>
          :
          <div className={stylesModal.center}>
            <div className={stylesModal.column} style={{ justifyContent: "space-between", alignItems: "start", width: "420px", overflowY: "scroll", scrollbarWidth: "none", height: "80vh", overflowX: "hidden" }}>
              <div>
                <h3 className={stylesModal.titleEvent}>{title}</h3>
                <p style={{ fontSize: "11pt", textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: message }} />
                {
                  imgUrl ?
                    <img src={imgUrl} width={420} height={200} className={stylesModal.imageEvent} alt="" />
                    : ""
                }
              </div>
              <div className={stylesModal.buttons} style={{ width: "100%" }}>
                <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
              </div>
            </div>
          </div>
      }
    </div>
  );
}

async function getCampaignGroups() {
  try {
    const res = await axios.get(`${Url}/campaign-groups?per_page=300`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await getCampaignGroups();
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getCampaignDetails(id) {
  try {
    const res = await axios
      .get(`${Url}/campaigns/${id}`, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await getCampaignDetails(id);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function addCampaign(title, message, group, date_start, date_end, calendar, saberMais, type) {
  if (title.trim() === "") return [0, <Alert type={"error"}>O título é obrigatório</Alert>];
  // else if (group === "") return [0, <Alert type={"error"}>O grupo de utilizadores é obrigatório</Alert>];
  else if (message.trim() === "") return [0, <Alert type={"error"}>A mensagem é obrigatória</Alert>];
  else if (date_start === "") return [0, <Alert type={"error"}>A data inicial é obrigatória</Alert>];
  else if (date_end === "") return [0, <Alert type={"error"}>A data final é obrigatória</Alert>];

  try {
    const res = await axios.post(`${Url}/campaigns`, {
      title: title,
      message: message,
      received_by: group.id,
      start_date: `${date_start}T00:00`,
      end_date: `${date_end}T00:00`,
      calendar: calendar,
      is_event: type === "evento" ? true : false,
      know_more: saberMais
    }, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [res.data.new_id, <Alert type={"success"}>{type === "Campanha" ? "Campanha adicionada" : "Evento adicionado"} com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await addCampaign(title, message, group, date_start, date_end, calendar, saberMais, type);
      else window.location.reload();
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : `Ocorreu um erro ao adicionar ${type}`);
      return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : `Ocorreu um erro ao adicionar ${type}`}</Alert>];
    }
  };
}

async function saveCampaign(id, title, message, group, date_start, date_end, saberMais, type) {
  if (title.trim() === "") return [0, <Alert type={"error"}>O título é obrigatório</Alert>];
  // else if (group === "") return [0, <Alert type={"error"}>O grupo de utilizadores é obrigatório</Alert>];
  else if (message.trim() === "") return [0, <Alert type={"error"}>A mensagem é obrigatória</Alert>];
  else if (date_start === "") return [0, <Alert type={"error"}>A data inicial é obrigatória</Alert>];
  else if (date_end === "") return [0, <Alert type={"error"}>A data final é obrigatória</Alert>];

  try {
    await axios
      .put(`${Url}/campaigns/${id}`, {
        title: title,
        message: message,
        received_by: group.id,
        start_date: `${date_start}T00:00`,
        end_date: `${date_end}T00:00`,
        is_event: type === "evento" ? true : false,
        know_more: saberMais
      }, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
    return [id, <Alert type={"success"}>{type === "Campanha" ? "Campanha editada" : "Evento editado"} com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await saveCampaign(id, title, message, group, date_start, date_end, saberMais, type);
      else window.location.reload();
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : `Ocorreu um erro ao editar ${type}`);
      return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : `Ocorreu um erro ao editar ${type}`}</Alert>];
    }
  };
}

function convertDateToInputFormat(inputDate) {
  if (!inputDate) return "";
  const dateParts = inputDate.split('/');
  const day = dateParts[0].padStart(2, '0');
  const month = dateParts[1].padStart(2, '0');
  const year = dateParts[2];

  return `${year}-${month}-${day}`;
}

function EditarCampanhas({ userPermissions }) {

  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const messageRef = useRef();
  const fileInputRef = useRef();
  const [loadingData, setLoadingData] = useState(true);
  const [alert, setAlert] = useState("");
  const [type, setType] = useState("");
  const [preview, setPreview] = useState("");

  const [title, setTitle] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [linkSaberMais, setLinkSaberMais] = useState("");

  const [groups, setGroups] = useState([]);
  const [groupValue, setGroupValue] = useState("");

  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");

  const [calendarCampaign, setCalendarCampaign] = useState(false);

  const handleImageUpload = () => fileInputRef.current.click();

  async function assignData() {
    const thisCampaignDetailsData = await getCampaignDetails(id);
    setType(thisCampaignDetailsData.is_event ? "evento" : "campanha");
    setTitle(thisCampaignDetailsData.title ?? "");
    setGroupValue(thisCampaignDetailsData.campaign_group ?? "");
    setMensagem(thisCampaignDetailsData.message ?? "");
    setFileName(thisCampaignDetailsData.uri ?? "");
    setDateStart(convertDateToInputFormat(thisCampaignDetailsData.start_date) ?? "");
    setDateEnd(convertDateToInputFormat(thisCampaignDetailsData.end_date) ?? "");
    setLinkSaberMais(thisCampaignDetailsData.know_more ?? "");
    setLoadingData(false);
  }

  async function fetchGroups() {
    const thisGroupsData = await getCampaignGroups();
    setGroups(thisGroupsData.items);
  }

  useEffect(() => {
    fetchGroups();
  }, []);

  async function getAlertEdit() {
    await setAlert("");
    if (id && file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        await axios.post(`${Url}/campaigns/${id}/image`, formData, {
          headers: {
            Authorization: "Bearer " + getUser().token,
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((res) => setFileName(res.data.path));
      }
      catch (err) {
        if (err.request && err.request.status === 401) {
          var newToken = await RefreshToken(err);
          if (newToken) {
            return await getAlertEdit();
          }
          else {
            window.location.reload();
          }
        }
        else {
          console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o ficheiro");
          return setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o ficheiro"}</Alert>);
        }
      }
    }
    const res = await saveCampaign(id, title, mensagem, groupValue ?? groups[0], dateStart, dateEnd, linkSaberMais, type);
    setAlert(res[1]);
    assignData();
  }

  async function getAlertAdd() {
    await setAlert("");
    const res = await addCampaign(title, mensagem, groupValue ?? groups[0], dateStart, dateEnd, calendarCampaign, linkSaberMais, type);
    if (res[0] && file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        await axios.post(`${Url}/campaigns/${res[0]}/image`, formData, {
          headers: {
            Authorization: "Bearer " + getUser().token,
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((res) => setFileName(res.data.path));
      }
      catch (err) {
        if (err.request && err.request.status === 401) {
          var newToken = await RefreshToken(err);
          if (newToken) {
            return await getAlertAdd();
          }
          else {
            window.location.reload();
          }
        }
        else {
          console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o ficheiro");
          return setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o ficheiro"}</Alert>);
        }
      }
    }
    setAlert(res[1]);
  }

  function handleMessageChange(e) {
    setMensagem(e.target.value.replace(/\\/g, ''));
  }

  function handleBoldText(type) {
    const input = messageRef?.current;
    if (input) {
      const start = input.selectionStart;
      const end = input.selectionEnd;
      var selectedText = input.value.substring(start, end);
      if (selectedText === "") {

        let modifiedText = "";

        if (input.value.substring(start - 3, start + 4) === `<${type}></${type}>`) {
          modifiedText = false;
        }
        else {
          modifiedText = `<${type}></${type}>`;
        }

        const newText = modifiedText ? input.value.substring(0, start) + modifiedText + input.value.substring(end) : input.value.substring(0, start - 3) + input.value.substring(start + 4, input.value.length);
        setMensagem(newText);

        let newStart = modifiedText ? start + 3 : start - 3;

        setTimeout(() => {
          input.focus();
          input.setSelectionRange(newStart, newStart);
        }, 0);
      }
      else {
        let modifiedText = "";

        if (selectedText.substring(0, 3) === `<${type}>` && selectedText.substring(selectedText.length - 4, selectedText.length) === `</${type}>`) {
          modifiedText = `${selectedText.slice(3, selectedText.length - 4)}`;
        }
        else {
          modifiedText = `<${type}>${selectedText}</${type}>`;
        }
        const newText = input.value.substring(0, start) + modifiedText + input.value.substring(end);
        setMensagem(newText);

        let newStart = start;
        let newEnd = end;
        if (selectedText.substring(0, 3) === `<${type}>` && selectedText.substring(selectedText.length - 4, selectedText.length) === `</${type}>`) {
          newEnd = start + (end - start - 7);
        } else {
          newEnd = start + modifiedText.length;
        }
        setTimeout(() => {
          input.focus();
          input.setSelectionRange(newStart, newEnd);
        }, 0);
      }

    }
  }

  function handleFileChange(e) {
    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
    const thisFile = e.target.files[0];
    if (allowedTypes.includes(thisFile.type)) {
      setFile(thisFile);
      setFileName(thisFile.name);
    }
    else {
      return setAlert(<Alert type="error">Apenas são aceites os seguintes formatos: .pdf, .jpg, .jpeg e .png</Alert>)
    }
  }

  useEffect(() => {
    if (id)
      assignData();
    else
      setLoadingData(false);
  }, []);

  return (
    <div className="body">
      {alert}
      {preview}
      <NavBar current={"campanhas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ?
          ""
          :
          (type === "campanha" || type === "evento")
            ?
            <div className={styles.content}>
              <GoBack backRoute={`/campanhas`} backState={state?.page ? { page: state.page } : {}} />
              {
                id ?
                  <h1 className={styles.backgroundName}>Editar {type}</h1>
                  :
                  <h1 className={styles.backgroundName}>Adicionar {type}</h1>
              }
              <div className={styles.formBlock}>
                <div className={styles.formBlockSection} style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
                  <p>Título:</p>
                  <input
                    defaultValue={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
                {/*<Dropdown
              label={"Grupo:"}
              placeholder={"Escolher grupo de utilizadores "}
              items={groups}
              onUrlChange={fetchGroups}
              value={groupValue}
              onValueChange={setGroupValue}
        />*/}
                <div className={styles.formBlockSection} style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
                  <p>Mensagem:</p>
                  <div style={{ width: "100%", paddingRight: "1rem" }}>
                    {
                      mensagem?.length > 0 ?
                        <div className={styles.textButtons}>
                          <button className={styles.textButton} style={{ fontWeight: "bold" }} onClick={() => handleBoldText("b")}>B</button>
                          <button className={styles.textButton} style={{ fontStyle: "italic" }} onClick={() => handleBoldText("i")}>I</button>
                          <button className={styles.textButton} style={{ textDecoration: "underline" }} onClick={() => handleBoldText("u")}>U</button>
                        </div>
                        : ""
                    }
                    <TextareaAutosize
                      ref={messageRef}
                      onKeyDown={(e) => {
                        if (e.key === "\\") return;
                      }}
                      style={{ resize: "vertical" }}
                      value={mensagem}
                      onChange={(e) => handleMessageChange(e)}
                    />
                  </div>
                </div>
                <div className={styles.formBlockSection} style={{ padding: "0.5rem" }}>
                  <div className={styles.actions}>
                    {
                      fileName ?
                        <HiXCircle onClick={() => { setFile(""); setFileName(""); }} className={styles.icon} size={22} />
                        : <HiPlusCircle onClick={() => handleImageUpload()} className={styles.icon} size={22} />
                    }
                  </div>
                  <p>
                    Imagem/Pdf:
                  </p>
                  {
                    fileName ?
                      <div style={{ display: "flex", width: "100%", gap: "10px", justifyContent: "space-between" }}>
                        <p style={{ fontSize: "12pt", color: "var(--text)", wordBreak: "break-all", userSelect: "none" }}>{fileName}</p>
                      </div>
                      :
                      <input
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        type="file"
                        value={file}
                        onChange={(e) => handleFileChange(e)}
                      />
                  }
                </div>
                <div className={styles.formBlockSection}>
                  <p>Link (saber mais):</p>
                  <input
                    defaultValue={linkSaberMais}
                    onChange={(e) => setLinkSaberMais(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Data inicial:</p>
                  <input
                    type="date"
                    defaultValue={dateStart}
                    onChange={(e) => setDateStart(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Data final:</p>
                  <input
                    type="date"
                    defaultValue={dateEnd}
                    min={dateStart}
                    onChange={(e) => setDateEnd(e.target.value)}
                  />
                </div>
                {
                  id ? ""
                    :
                    <div className={styles.formBlockSection} style={{ width: "fit-content", padding: "0.5rem 1rem" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                        <p style={{ fontSize: "11pt" }}>Adicionar {type} à agenda ?</p>
                        <Switch value={calendarCampaign} setValue={setCalendarCampaign} />
                      </div>
                    </div>
                }
              </div>
              <div style={{ display: "flex", gap: "1rem" }}>
                <button disabled={mensagem.trim() === "" || title.trim() === ""} style={mensagem.trim() === "" || title.trim() === "" ? { opacity: "0.8", cursor: "not-allowed" } : {}} className={styles.btn} onClick={() => setPreview(<PreviewModal closeModal={setPreview} message={mensagem.replaceAll("\n", "<br>")} title={title} file={file} filename={fileName} />)}>Pré-visualizar</button>
                {
                  id ?
                    <button className={styles.btn} onClick={() => getAlertEdit()}>Guardar alterações</button>
                    :
                    <button className={styles.btn} onClick={() => getAlertAdd()}>Adicionar {type}</button>
                }
              </div>
            </div>
            :
            <div className={styles.content}>
              <h1 className={styles.backgroundName}>Adicionar</h1>
              <div className={styles.newsTypes}>
                <button onClick={() => setType("campanha")}><HiOutlineMegaphone size={100} />Campanha</button>
                <button onClick={() => setType("evento")}><HiOutlineMegaphone size={100} style={{ transform: "scale(-1, 1)" }} />Evento</button>
              </div>
            </div>
      }
    </div>
  );
}

export default EditarCampanhas;